// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  firebaseConfig: {
    apiKey: "AIzaSyALPDZ5um7flrifa-h33WXQhBxKPdpVpIc",
    authDomain: "megastore-f7488.firebaseapp.com",
    projectId: "megastore-f7488",
    storageBucket: "megastore-f7488.firebasestorage.app",
    messagingSenderId: "93257152717",
    appId: "1:93257152717:web:9ab318c81c6db032f81184",
    measurementId: "G-QHKZJB29RV",
    vapidKey:
      'BBm_k5Jn34CI9Ix9U8EXJN30o6qdgQnXKUVNdHBxocb_FX2ZMmsb7eBBPTddjevYWX3Orr57UNmBU0uBvJPBsX8'
  },

  path: '/firebase-messaging-sw.js',
  scope: '/',

  production: false,
  base_url: 'https://api-dev.mega-store.app/user/api/v1/',
  common_url: 'https://api-dev.mega-store.app/common/api/v1/',
  operational_url:
    'https://api-dev.mega-store.app/operational/api/v1/',
  socketUrl: 'https://operational-api-dev.mega-store.app',
  verificationTimer: 'verificationTimerValue',
  storageKey: 'megastoreWebAccessToken',
  guestTokenKey: 'guestTokenKey',
  rememberMeKey: 'isRememberMegastoreWeb',
  appId: '64b28b70be1bb83550343cfd',
  googleKey: 'AIzaSyALPDZ5um7flrifa-h33WXQhBxKPdpVpIc',
  selectedLang: 'selectedLanguage',
  bagDetails: 'bagDetails',
  currentAddress:'currentAddress',
  upadedbagDetails: 'updatedBagDetails',
  payment_url: 'https://payments.mega-store.app/operational/api/v1/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
